var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/SellForMoreShowcaseUpsell/SellForMoreShowcaseUpsellTemplate.jsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import marked from 'marked';
import { Box, Button, Heading, Paragraph, Popover, Text, TextButton } from '@zillow/constellation';
import { Divider } from '@zillow/constellation/lib/components';
import { ShowcaseMarkDownTextWithToolTip } from '../DualHookShowcaseUpsell/ShowcaseMarkDownTextWithToolTip';
import { formatListingPrice, formatPercentagePrice } from '../../../../../utils/currencyFormatting';
import { calculateOfferValues } from '../../../../../utils/calculateOfferValues';
var StyledHeading = styled(Heading).withConfig({
  displayName: "SellForMoreShowcaseUpsellTemplate__StyledHeading",
  componentId: "sc-1v8bcqb-0"
})(["font-weight:700;font-size:20px;line-height:24px;", ""], function (_ref) {
  var forceColumnLayout = _ref.forceColumnLayout;
  return !forceColumnLayout && css(["@media (min-width:600px){font-size:24px;line-height:32px;}"]);
});

var SellForMoreShowcaseUpsellTemplate = function SellForMoreShowcaseUpsellTemplate(_ref2) {
  var titleText = _ref2.titleText,
      subtitleText = _ref2.subtitleText,
      subtitleTextTooltipHeading = _ref2.subtitleTextTooltipHeading,
      subtitleTextTooltipBody = _ref2.subtitleTextTooltipBody,
      subtitleTextTooltipButtonActionLink = _ref2.subtitleTextTooltipButtonActionLink,
      subtitleTextTooltipButtonText = _ref2.subtitleTextTooltipButtonText,
      firstRowText = _ref2.firstRowText,
      firstRowTextTooltipHeading = _ref2.firstRowTextTooltipHeading,
      firstRowTextTooltipBody = _ref2.firstRowTextTooltipBody,
      firstRowTextTooltipButtonActionLink = _ref2.firstRowTextTooltipButtonActionLink,
      firstRowTextTooltipButtonText = _ref2.firstRowTextTooltipButtonText,
      percentIncrease = _ref2.percentIncrease,
      secondRowText = _ref2.secondRowText,
      emphasizePercent = _ref2.emphasizePercent,
      thirdRowText = _ref2.thirdRowText,
      thirdRowSubText = _ref2.thirdRowSubText,
      standingOfferPrice = _ref2.standingOfferPrice,
      emphasizeShowcase = _ref2.emphasizeShowcase,
      actionText = _ref2.actionText,
      onActionButtonClick = _ref2.onActionButtonClick,
      forceColumnLayout = _ref2.forceColumnLayout;

  var _calculateOfferValues = calculateOfferValues(standingOfferPrice, percentIncrease),
      _calculateOfferValues2 = _slicedToArray(_calculateOfferValues, 3),
      zestimatePrice = _calculateOfferValues2[0],
      showcasePrice = _calculateOfferValues2[1],
      earningsDifference = _calculateOfferValues2[2];

  var formattedZestimatePrice = formatListingPrice(zestimatePrice);
  var formattedShowcasePrice = formatListingPrice(showcasePrice);
  var formattedEarningsDifference = formatPercentagePrice(earningsDifference);
  var titleTextNode = /*#__PURE__*/React.createElement(StyledHeading, {
    forceColumnLayout: forceColumnLayout,
    level: 5,
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(titleText)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  });
  var subtitleTextPopover = /*#__PURE__*/React.createElement(Popover, {
    modal: false,
    header: /*#__PURE__*/React.createElement(Heading, {
      level: "6",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 21
      }
    }, subtitleTextTooltipHeading),
    body: /*#__PURE__*/React.createElement(React.Fragment, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Paragraph, {
      fontType: "body",
      marginBottom: 2,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 21
      }
    }, subtitleTextTooltipBody), /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      href: subtitleTextTooltipButtonActionLink,
      target: "_blank",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 21
      }
    }, subtitleTextTooltipButtonText)),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  });
  var subtitleTextNode = /*#__PURE__*/React.createElement(ShowcaseMarkDownTextWithToolTip, {
    markdownTextInput: subtitleText,
    bodyTooltipPopover: subtitleTextPopover,
    fontType: "body",
    showTooltipTriggerUnderline: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 9
    }
  });
  var firstRowTextPopover = /*#__PURE__*/React.createElement(Popover, {
    modal: false,
    header: /*#__PURE__*/React.createElement(Heading, {
      level: "6",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96,
        columnNumber: 21
      }
    }, firstRowTextTooltipHeading),
    body: /*#__PURE__*/React.createElement(React.Fragment, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Paragraph, {
      fontType: "body",
      marginBottom: 2,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 21
      }
    }, firstRowTextTooltipBody), /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      href: firstRowTextTooltipButtonActionLink,
      target: "_blank",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 21
      }
    }, firstRowTextTooltipButtonText)),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 9
    }
  });
  var firstRowTextNode = /*#__PURE__*/React.createElement(ShowcaseMarkDownTextWithToolTip, {
    markdownTextInput: firstRowText,
    bodyTooltipPopover: firstRowTextPopover,
    fontType: "bodySmall",
    showTooltipTriggerUnderline: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 9
    }
  });
  var actionButton = /*#__PURE__*/React.createElement(Button, {
    buttonType: "primary",
    onClick: onActionButtonClick,
    fluid: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 9
    }
  }, actionText);
  return /*#__PURE__*/React.createElement(Box, {
    sx: Object.assign(Object.assign({
      'display': 'flex',
      'flexDirection': 'column',
      'backgroundColor': '$colors.white',
      'margin': '0 auto',
      'padding': '$spacing.sm',
      'gap': '$spacing.sm'
    }, forceColumnLayout ? {
      padding: '0'
    } : {
      'maxWidth': '688px',
      '@media screen and (min-width: 600px)': {
        gap: '$spacing.md'
      }
    }), {}, {
      '@media screen and (max-width: 321px)': {
        padding: '$spacing.xs'
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 9
    }
  }, titleTextNode, /*#__PURE__*/React.createElement(Box, {
    sx: Object.assign({
      display: 'flex',
      flexDirection: 'column',
      gap: '$spacing.sm'
    }, !forceColumnLayout ? {
      '@media screen and (min-width: 600px)': {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: '$spacing.md'
      }
    } : {}),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: Paragraph,
    fontType: "body",
    sx: Object.assign({}, !forceColumnLayout ? {
      '@media screen and (min-width: 600px)': {
        width: '50%'
      }
    } : {}),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 17
    }
  }, subtitleTextNode), /*#__PURE__*/React.createElement(Box, {
    sx: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, !forceColumnLayout ? {
      '@media screen and (min-width: 600px)': {
        marginTop: '0px',
        width: '50%'
      }
    } : {}),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: "first-row",
    sx: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodySmall",
    fontColor: "blue400",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 201,
      columnNumber: 25
    }
  }, firstRowTextNode), /*#__PURE__*/React.createElement(Text, {
    fontType: "body",
    fontColor: "textMedium",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 204,
      columnNumber: 25
    }
  }, formattedZestimatePrice)), /*#__PURE__*/React.createElement(Box, {
    className: "second-row",
    sx: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 208,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodySmall",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 217,
      columnNumber: 25
    }
  }, secondRowText), /*#__PURE__*/React.createElement(Text, {
    fontType: emphasizePercent ? 'h4' : 'bodyHeading',
    fontColor: emphasizePercent ? 'green500' : 'blue400',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 25
    }
  }, "+ ", formattedEarningsDifference)), /*#__PURE__*/React.createElement(Divider, {
    marginY: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Box, {
    className: "third-row",
    sx: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 226,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 235,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodySmall",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 242,
      columnNumber: 29
    }
  }, thirdRowText), /*#__PURE__*/React.createElement(Text, {
    fontType: "legal",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 243,
      columnNumber: 29
    }
  }, thirdRowSubText)), /*#__PURE__*/React.createElement(Text, {
    fontType: emphasizeShowcase ? 'h4' : 'bodyHeading',
    fontColor: emphasizeShowcase ? 'green500' : 'blue400',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 245,
      columnNumber: 25
    }
  }, formattedShowcasePrice)))), actionButton);
};

SellForMoreShowcaseUpsellTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  titleText: PropTypes.string,
  subtitleText: PropTypes.string,
  subtitleTextTooltipHeading: PropTypes.string,
  subtitleTextTooltipBody: PropTypes.string,
  subtitleTextTooltipButtonActionLink: PropTypes.string,
  subtitleTextTooltipButtonText: PropTypes.string,
  firstRowText: PropTypes.string,
  firstRowTextTooltipHeading: PropTypes.string,
  firstRowTextTooltipBody: PropTypes.string,
  firstRowTextTooltipButtonActionLink: PropTypes.string,
  firstRowTextTooltipButtonText: PropTypes.string,
  percentIncrease: PropTypes.string,
  secondRowText: PropTypes.string,
  emphasizePercent: PropTypes.bool,
  thirdRowText: PropTypes.string,
  thirdRowSubText: PropTypes.string,
  standingOfferPrice: PropTypes.string.isRequired,
  emphasizeShowcase: PropTypes.bool,
  actionText: PropTypes.string,
  onActionButtonClick: PropTypes.func,
  forceColumnLayout: PropTypes.bool
} : {};
export default SellForMoreShowcaseUpsellTemplate;